import * as THREE from 'three'
import NidoPart, {
  NidoPartParameters,
} from '~/service/experience/world/nido/parts/NidoPart'
import {
  NidoCageType,
  NidoCode,
  NidoId,
} from '~/service/experience/world/nido/enum'
import { Nido } from '~/service/experience/world/nido/Nido'

export class NidoCage extends NidoPart {
  material: NidoCageType

  constructor(
    parent: Nido,
    scene: THREE.Group,
    model: THREE.Mesh,
    parameters: NidoPartParameters,
    cageType: NidoCode,
    material: NidoCageType
  ) {
    super(parent, scene, model, parameters, cageType, NidoId.NONE)
    this.material = material
  }

  // lowBackrest: NidoLowBackrest | NidoLowCornerBackrest | undefined

  addLowBackrest() {
    //
  }

  invert() {
    super.invert()

    // if(this.lowBackrest) {
    //   this.lowBackrest.invert()
    // }
  }

  toJSON() {
    const json = super.toJSON()

    const obj = JSON.parse(json)

    obj.type = 'cage'

    obj.cageType = this.code

    return JSON.stringify(obj, null, '\t')
  }
}

export class NidoMetalCage extends NidoCage {
  constructor(
    parent: Nido,
    scene: THREE.Group,
    parameters: NidoPartParameters,
    cageType: NidoCode
  ) {
    let model = parent.resources.models.cageSingle

    switch (cageType) {
      case NidoCode.CAGE_SINGLE:
        model = parent.resources.models.cageSingle
        break
      case NidoCode.CAGE_DOUBLE:
        model = parent.resources.models.cageDouble
        break
      case NidoCode.CAGE_TRIPLE:
        model = parent.resources.models.cageTriple
        break
      case NidoCode.CAGE_CORNER:
        model = parent.resources.models.cageCorner
        break
    }
    super(parent, scene, model, parameters, cageType, NidoCageType.METAL)
  }

  // lowBackrest: NidoLowBackrest | NidoLowCornerBackrest | undefined

  addLowBackrest() {
    //
  }

  invert() {
    super.invert()

    // if(this.lowBackrest) {
    //   this.lowBackrest.invert()
    // }
  }

  toJSON() {
    const json = super.toJSON()

    const obj = JSON.parse(json)

    obj.type = 'cage'
    obj.material = NidoCageType.METAL

    obj.cageType = this.code

    return JSON.stringify(obj, null, '\t')
  }
}

export class NidoWoodenCage extends NidoCage {
  constructor(
    parent: Nido,
    scene: THREE.Group,
    parameters: NidoPartParameters,
    cageType: NidoCode
  ) {
    let model = parent.resources.models.cageWoodenSingle

    switch (cageType) {
      case NidoCode.CAGE_SINGLE:
        model = parent.resources.models.cageWoodenSingle
        break
      case NidoCode.CAGE_DOUBLE:
        model = parent.resources.models.cageWoodenDouble
        break
      case NidoCode.CAGE_TRIPLE:
        model = parent.resources.models.cageWoodenTriple
        break
      case NidoCode.CAGE_CORNER:
        model = parent.resources.models.cageWoodenCorner
        break
    }
    super(parent, scene, model, parameters, cageType, NidoCageType.WOOD)
  }

  // lowBackrest: NidoLowBackrest | NidoLowCornerBackrest | undefined

  addLowBackrest() {
    //
  }

  invert() {
    super.invert()

    // if(this.lowBackrest) {
    //   this.lowBackrest.invert()
    // }
  }

  toJSON() {
    const json = super.toJSON()

    const obj = JSON.parse(json)

    obj.type = 'cage'
    obj.material = NidoCageType.WOOD

    obj.cageType = this.code

    return JSON.stringify(obj, null, '\t')
  }
}
